import type { BackendPaymentProcessorResponse } from '~/types/payment/paymentBackendTypes'
import calculatePaymentFee from '~/utils/calculations/PaymentProcessors/calculatePaymentFee'

export default (processors: BackendPaymentProcessorResponse[], amount: number) => {
  processors.forEach((processor) => {
    processor.amount = amount

    if (processor.fee_type !== null) {
      const fee = calculatePaymentFee(amount, processor.fee_type, processor.fee !== null ? processor.fee : 0.0)

      processor.amount += fee
    }

    processor.amount = parseFloat(processor.amount.toString()).toFixed(2)
  })

  return processors
}
